// The codes a printer needs, as CSV — a pure function so it is testable under
// the admin vitest setup (see cash.custody.ts for why that matters).

/**
 * One row per pass: the code the QR must encode, and its current status.
 *
 * ⚠ THE CODE IS THE BEARER INSTRUMENT. Whoever holds this file can spend every
 * active pass in it, exactly as whoever holds the printed card can. The page
 * says so where the button is.
 */
export function giftpassCsv(passes: { display_code: string; status: string }[]): string {
  const rows = [...passes]
    .sort((a, b) => a.display_code.localeCompare(b.display_code))
    .map((p) => `${p.display_code},${p.status}`);
  return ["code,status", ...rows].join("\r\n") + "\r\n";
}

/** A filename that sorts by batch label and date. */
export function giftpassCsvName(label: string, now: Date = new Date()): string {
  const slug =
    label
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .slice(0, 40) || "batch";
  const day = new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Manila" }).format(now);
  return `giftpass-${slug}-${day}.csv`;
}
